const Redirect = ({form, setForm }) => {
  return (
    <div className="AddInfoContainer">
      <label>لینک قدیم</label>
      <input className="persianName" placeholder="خالی بماند = لینک همین محصول" defaultValue={form?.oldUrl} onChange={(input) => setForm((prev) => ({...prev, oldUrl: input.target.value}))}/>
      <label>لینک جدید</label>
      <input className="persianName" placeholder="مثلا https://parsianled.com" defaultValue={form?.newUrl} onChange={(input) => setForm((prev) => ({...prev, newUrl: input.target.value}))}/>
      <small dir="rtl">اگر لینک قدیم خالی بماند، صفحه همین محصول به لینک جدید منتقل می‌شود. برای حذف ریدایرکت هر دو فیلد را خالی کنید.</small>
    </div>
  );
};

export default Redirect;
